import { Button, ButtonsGroup, Heading, PageHeader, PageWrapper } from "#/atoms";
import { CustomTable, FilterAction, ResponsiveCell } from "#/molecules";
import { FC, memo, useMemo } from "react";

import { Column } from 'react-table';
import { CustomersProps } from "./Customers.interface";
import { NATURAL } from "@/theme";

const Customers: FC<CustomersProps> = ({
  customers,
  loadingCustomers,
  numberOfFilters,
  onCreateNewCustomer,
  onDownloadAddress,
  onOpenFilter,
  onOpenInviteModal,
  onShowMore,
  onClickRow,
  shouldShowMore
}) => {
  const data = useMemo(() => (customers.map((customer) => ({
    active: customer.active ? 'Yes' : 'No',
    address: customer.address,
    branchId: customer.branchId,
    code: customer.code,
    companyName: customer.companyName,
    email: customer.email,
    id: customer.id,
    invited: customer.invited,
    name: `${customer.firstName} ${customer.lastName}`,
    upsell: customer.upsell,
  }))), [customers]);
  
  const columns: Column[] = useMemo(() => [
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Name" value={value}></ResponsiveCell>;
      },
      Header: 'Name',
      accessor: 'companyName',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Display Name" value={value} ></ResponsiveCell>;
      },
      Header: 'Display Name',
      accessor: 'name',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Customer Code" value={value} ></ResponsiveCell>;
      },
      Header: 'Customer Code',
      accessor: 'code',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Address" value={value} ></ResponsiveCell>;
      },
      Header: 'Address',
      accessor: 'address',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Email" value={value} ></ResponsiveCell>;;
      },
      Header: 'Email Address',
      accessor: 'email',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Active" value={value} ></ResponsiveCell>;;
      },
      Header: 'Active',
      accessor: 'active',
    },
    {
      Cell: ({ value }) => {
        return  <ResponsiveCell label="Upsell" value={value} ></ResponsiveCell>;
      },
      Header: 'Upsell (GBP)',
      accessor: 'upsell',
    },
    {
      Cell: ({ data: rawData, row, value }) => {
        if (rawData[row.index].invited) {
          return null;
        }
        
        return (
          <Button
            actionType='outline'
            onClick={(ev) => { ev.stopPropagation(); onOpenInviteModal(value)}}
            buttonSize="sm"
          >
            Invite
          </Button>
        );
      },
      Header: '',
      accessor: 'id',
      id: 'id',
    },
  ], []);

  const handleRowClick = (rawData: object) => {
    onClickRow?.(rawData['id'], rawData['branchId']);
  }

  return (
    <PageWrapper>
      <PageHeader>
        <Heading scale="h1" fontColor={NATURAL.K}>Customers</Heading>
        {/* <Typo fontColor={NATURAL.G} fontSize={FONT_SIZE.SM}>Description text here.</Typo> */}
        <ButtonsGroup>
          <Button actionType='outline' onClick={onDownloadAddress}>Download Address List</Button>
          <Button onClick={onCreateNewCustomer}>Create New Customer</Button>
        </ButtonsGroup>
      </PageHeader>
      <FilterAction numberOfFilters={numberOfFilters} onOpen={onOpenFilter} />
      <CustomTable columns={columns} data={data} rowProps={({ cursor: 'pointer' })} loading={loadingCustomers} onClickRow={handleRowClick} />
      {shouldShowMore && <ButtonsGroup>
          <Button onClick={onShowMore}>Show More</Button>
        </ButtonsGroup> }
    </PageWrapper>
  );
}

export default memo(Customers);